module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.user_in_group
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateAssignedToId()
      }]
    }
  }, _vm._l((_vm.allowed_groups), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id,
        "selected": option.id == _vm.assigned_to_id
      }
    }, [_vm._v("\n                " + _vm._s(option.full_name) + "\n            ")])
  }), 0)])])]), _vm._v(" "), (_vm.user_in_group && !_vm.user_is_assignee) ? _c('div', [_c('a', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        return _vm.updateAssignedToId('current_user')
      }
    }
  }, [_vm._v("\n            Assign to me\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Currently assigned to")]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-798d18c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/assignment.vue
// module id = 1016
// module chunks = 0